import axios from "axios";
import TokenService from "./token.service";

const FILES_API_URL = import.meta.env.VITE_FILES_API_URL + import.meta.env.VITE_BASE_PATH

class FilesService {
  uploadFileToS3(file) {
    const token = TokenService.getLocalAccessToken();

    const formData = new FormData();
    formData.append("file", file);

    return axios.post(FILES_API_URL+`v2/api/files`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => ({ data: response.data }));
  }
}

export default new FilesService();

